module.exports = __webpack_public_path__ + "img/贾向敬.85c6b670.jpg";